/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

$(".miniCart").on("mouseover", function () {
  $("#cart-container").addClass("cart--active");
  const trackingInfo = JSON.parse(document.querySelector('#view-cart-gtm').content.textContent);
});

$("#cart-container").on("mouseleave", function () {
  $(this).removeClass("cart--active");
});

$(".btn--secondary.cart__button").click(function() {
  $("#cart-container").removeClass("cart--active");

  // hide mobile mini-cart
  $(document.documentElement).removeClass('offCanvasBasket')
})

$('.js-cart').on("cartOpen", function() {
  $(".btn--secondary.cart__button").click(function() {
    $("#cart-container").removeClass("cart--active");

    // hide mobile mini-cart
    $(document.documentElement).removeClass('offCanvasBasket')
  })
})

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {

  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);

      newDataLayerPush(line_item, form);
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'button[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $('form[action^="/cart/add"]');
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find('button[type="submit"]');
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }




    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {


// work out basket count ignoring hidden bike bundle products:
var cartCount = 0; var isAValidItem;
$.each(cart.items, function(innerIndex, innerCartItem) {
 isAValidItem = true;
for(var thisInnerCartItem in innerCartItem.properties) {
  if(thisInnerCartItem.indexOf("parentLineItem") != -1 || thisInnerCartItem.indexOf("_bundle-master") != -1) {
    isAValidItem = false;
  }
}
if(isAValidItem) {
 cartCount += innerCartItem.quantity; 
}
});

  
    if ($cartCountSelector) {
      $cartCountSelector.html(cartCount).removeClass('hidden-count');

      if (cartCount === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {

    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      // Cart API
      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added').delay(4000).queue(function(rvt) {
    	$addToCart.removeClass('is-added');
    	rvt();
    });
    $('#GoToCheckout').css('display', 'block');

    ShopifyAPI.getCart(cartUpdateCallback);
    if($('.toggle-menu').is(":visible")) {
      renderMiniCart();
      $("html").addClass("offCanvasBasket");
      $('html, body').animate({
          scrollTop: 0
      }, 600);
      setTimeout(function(){ $("html").removeClass("offCanvasBasket"); }, 4000);
      } else {
        renderMiniCart();
          $('#cart-container').addClass('cart--active');
          setTimeout(function() {
            $('#cart-container').removeClass('cart--active');
          }, 3000);
      }
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $('.product-switcher').after('<div class="errors qty-error button-text">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<p class="empty-cart">' + "Your Shopping Basket is currently empty." + '</p>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);


var cartCount = 0;
var childProducts = [];


    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      if(cartItem)

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        showQuantity: true,
        showRemove: false,
        variation: cartItem.variant_title,
           // properties: cartItem.properties,
        properties: [],
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
      };

var shouldShowThisItemInAjaxCart = true;
var isUpsellParent = false;

var primaryItemProperties = [];




for(var thisCartItem in cartItem.properties) {

  if(thisCartItem.charAt(0) != "_")  {
    primaryItemProperties.push(thisCartItem+': '+cartItem.properties[thisCartItem]);
  }

  if(thisCartItem.indexOf("_parentLineItem") != -1 || thisCartItem.indexOf("bundle-master") != -1) {
    shouldShowThisItemInAjaxCart = false;
  }

  if (thisCartItem.indexOf("set-price") != -1) {
    var setPrice = parseInt(cartItem.properties[thisCartItem])
    item.linePrice = Shopify.formatMoney(setPrice, settings.moneyFormat);
    item.showQuantity = false;
  }
  
  if(thisCartItem.indexOf("_primaryParentLineItem") != -1 ) {
    var parentProductId = cartItem.properties[thisCartItem];
    isUpsellParent = true;
    // look for related upsell product
    var priceIncrease = 0;
    $.each(cart.items, function(innerIndex, innerCartItem) {
      for(var thisInnerCartItem in innerCartItem.properties) {
        if(thisInnerCartItem.indexOf("_parentLineItem") != -1 ) {
          if(innerCartItem.properties[thisInnerCartItem] == parentProductId) {
            priceIncrease += (innerCartItem.price * innerCartItem.quantity);
            childProducts.push(innerCartItem.title);
          }
        }
      }
    });
    if(priceIncrease>0) {
      item.linePrice = Shopify.formatMoney(cartItem.line_price + priceIncrease, settings.moneyFormat);
      item.price = Shopify.formatMoney(cartItem.price + (priceIncrease * cartItem.quantity), settings.moneyFormat);
    }
    if(childProducts.length>0) {
      item.childProducts = childProducts;
    }
  }

  if(thisCartItem.indexOf("_swatch_product") != -1 ) {
    item.showQuantity = false;
    item.showRemove = true;
  }
}

if(primaryItemProperties.length>0) {
item.childProducts = primaryItemProperties.concat(item.childProducts);
}


if(isUpsellParent) {
  item.showQuantity = false;
}

if(shouldShowThisItemInAjaxCart) {
  items.push(item);
  cartCount += cartItem.quantity;
}



    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      cartCount: cartCount,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true,
    }

var freeShippingTarget = parseInt(9999);

//controls the messaging in the minicart
let propArr = [];
$.ajax({
  url: '/cart.js',
  async: false,
  dataType: 'json',
  success: function (cart) {
    for (let i = 0; i < cart.items.length; i++) {
      if (cart.items[i].properties !== null) {
        if (cart.items[i].properties.hasOwnProperty('_datepicker') || cart.items[i].properties.hasOwnProperty('_2man')) {
          propArr.push(true);
        } else {
          propArr.push(false);
        }
      }
    }
  }
});
const hideFreeDeliveryMsg = propArr.includes(true);

if (hideFreeDeliveryMsg && cart.total_price >= freeShippingTarget) {
  data.freeDeliveryMessage = '';
  data.freeDeliveryBarHTML = '';
} else if (cart.total_price >= freeShippingTarget) {
  data.freeDeliveryMessage = "You've qualified for free UK delivery";
  data.freeDeliveryBarHTML = '';
} else {
  var shippingDifference = Shopify.formatMoney((freeShippingTarget - cart.total_price), settings.moneyFormat);
  data.freeDeliveryMessage = "You are ## away from free UK delivery";
  data.freeDeliveryMessage = data.freeDeliveryMessage.replace('##', shippingDifference);
  var percentAchieved = (cart.total_price / freeShippingTarget) * 100;
  data.freeDeliveryBarHTML = '<div id="freeDeliveryGauge"><span style="width: ' + percentAchieved + '%"></span></div>';
}
  
  
  $cartContainer.append(template(data));
  
    cartCallback(cart);
if(typeof BOLD === 'object' && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
  BOLD.common.eventEmitter.emit('BOLD_COMMON_redirect_upsell_product');
}
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Remove item
    $body.on('click', '.ajaxcart__remove', function() {
      var $el = $(this);
      var line =  $el.data('line');
      updateQuantity(line, 0);
    });

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = parseInt($el.val()),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));

// dataLayerPush = function(line_item){
//   window.dataLayer = window.dataLayer || [];
//   dataLayer.push({
//     'event' : 'product_add',
//     'ecommerce': {
//       'detail': {
//         'products': [{
//           'name': line_item.title,
//           'id': line_item.id,
//           'price': line_item.price,
//           'brand': line_item.vendor
//         }]
//       }
//     }
//   });
// }

newDataLayerPush = function(line_item, form){
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "nk_add_to_cart",
    ecommerce: JSON.parse(form.querySelector('#product-data').innerText)
  });
}